export default __webpack_public_path__ + "static/media/steps.49f42669.svg";